import {apiConfig} from '@stencil/hotels-config';

const {__VOYAGERX__} = apiConfig;

export default function makeHotelStaticUrl({
  vhid,
  filter = {hctx: ''},
  // callPricing = false,
  // retry = true,
  fields = '',
  flavour = '',
}: // storeInstance,
{
  vhid: string;
  filter: {
    hctx?: string;
  };
  fields?: string;
  flavour?: 'mobile' | '';
}) {
  if (!vhid) {
    return '';
  }

  const {hctx = ''} = filter;
  const context = hctx ? `&context=["${hctx}"]` : '';
  const field = fields ? `&fields=["${fields}"]` : '';
  const flavourQuery = flavour ? `&flavour=${flavour}` : '';
  // ! share with Voyager team that v3 flavour is not being supported for Detail static data
  // flavour=v3&
  const url = `${__VOYAGERX__}/api/v2/hotels/get_hotels_static_data_v2/?tag=All&id=${vhid}${context}${field}${flavourQuery}`;
  return url;
}
